// extracted by mini-css-extract-plugin
export default {"lableStyle":"CommonLabel_lableStyle__Cp8xr","errorLabel":"CommonLabel_errorLabel__ja9p-"};